import ComboBoxProductCategory from './ComboBoxArticleCategory';
export default ComboBoxProductCategory;
